import dayjs, { Dayjs } from 'dayjs';
import moment, { Moment } from 'moment';
import { PICKER_DATE_MASK, SERVER_DATE_MASK } from 'shared/constants';
import {
  OvertimeCompensationType,
  OvertimeCompensationTypeBack,
  overtimeCompensationTypeFromBack,
  overtimeCompensationTypeToBack,
} from 'shared/enums/overtime';
import {
  RvdCompensationType,
  RvdCompensationTypeFromBack,
  RvdCompensationTypeToBack,
  RvdStatusFromBack,
} from 'shared/enums/rvd';

export const checkRvdCompensationType = (data: string): RvdCompensationType => {
  return Object.values(RvdCompensationType).includes(data as RvdCompensationType)
    ? data
    : RvdCompensationTypeFromBack[data];
};

export const checkRvdCompensationTypeToBack = (data: string): RvdCompensationType => {
  return Object.values(RvdCompensationTypeToBack).includes(data) ? data : RvdCompensationTypeToBack[data];
};

export const checkOvertimeCompensationType = (data: string): OvertimeCompensationType => {
  return Object.values(OvertimeCompensationType).includes(data as OvertimeCompensationType)
    ? data
    : overtimeCompensationTypeFromBack[data];
};

export const checkOvertimeCompensationTypeToBack = (data: string): OvertimeCompensationType => {
  return Object.values(overtimeCompensationTypeToBack).includes(data as OvertimeCompensationTypeBack)
    ? data
    : RvdCompensationTypeToBack[data];
};

export const momentFormatCheck = (date: string) => {
  let newDate: Dayjs;
  newDate = dayjs(date, PICKER_DATE_MASK);
  if (!newDate.isValid()) {
    newDate = dayjs(date, SERVER_DATE_MASK);
  }
  return newDate;
};
